import React from 'react';
import { Outlet } from 'react-router-dom';

export default function RouteWrapper(): JSX.Element {
  return <Outlet />;
}
